import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/veicoli/Veicoli.vue'),
		meta: {
			title: 'vehicles',
			acl: 'section.veicoli'
		}
	}
];

export default routes;